import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	crossTeamHeadingComplexspork: {
		id: 'business-trial-banner.modal.benefits-list.cross-team-heading-complexspork',
		defaultMessage: 'Cross-team planning and tracking',
		description:
			'Heading for showing highlight on primium with regard to Cross-team planning and tracking',
	},
	crossTeamDescriptionComplexspork: {
		id: 'business-trial-banner.modal.benefits-list.cross-team-description-complexspork',
		defaultMessage:
			'Create a Plan to schedule work, map dependencies, and report progress across multiple teams and projects.',
		description: 'Content describing the new Cross-team planning and tracking for teams on Premium',
	},
	aiHeadingComplexspork: {
		id: 'business-trial-banner.modal.benefits-list.ai-heading-complexspork',
		defaultMessage: 'Atlassian Intelligence',
		description: 'Heading for Jira Premium benefit of having new features in Jira',
	},
	aiFeaturesDescriptionComplexspork: {
		id: 'business-trial-banner.modal.benefits-list.ai-features-description-complexspork',
		defaultMessage: 'Accelerate work and minimize distractions with AI-powered search and editing.',
		description: 'Content describing the new AI features for teams on Jira Premium',
	},
	higherAutomationHeadingComplexspork: {
		id: 'business-trial-banner.modal.benefits-list.higher-automation-heading-complexspork',
		defaultMessage: 'Higher automation limits',
		description:
			'Heading describing the higher automation limits are available for Jira Premium users',
	},
	higherAutomationDescriptionComplexspork: {
		id: 'business-trial-banner.modal.benefits-list.higher-automation-description-complexspork',
		defaultMessage:
			'Freely leverage global automation to standardize best practices across your organization.',
		description:
			'Content describing the higher automation limits are available for Jira Premium users',
	},
	greaterAdminControlsHeadingComplexspork: {
		id: 'business-trial-banner.modal.benefits-list.greater-admin-controls-heading-complexspork',
		defaultMessage: 'Greater admin controls',
		description:
			'Heading describing that greater admin controls are available for Jira Premium users',
	},
	muchMoreDescriptionComplexspork: {
		id: 'business-trial-banner.modal.benefits-list.much-more-description-complexspork',
		defaultMessage:
			'Ensure a smooth and secure experience for end users with sandbox, release tracks, admin insights, IP allow listing, and more.',
		description: 'Content describing that much more is available for Jira Premium users',
	},
});
